import { Organization } from "src/types/graphql";
import * as RD from "src/types/remoteData";
import { BreadcrumbData } from ".";
import * as Url from "../url";
import { getBreadcrumbsForHome } from "./organization";

export const getBreadcrumbsForEdit = (
  organization: RD.RemoteData<unknown, Organization>
): BreadcrumbData[] => {
  return [
    ...getBreadcrumbsForHome(organization),
    organization.map((org) => ({
      label: "Settings",
      href: Url.OrgAdmin.Org.settings(org, "tools"),
    })),
    {
      label: "Landing page",
      href: organization
        .map((org) => Url.OrgAdmin.Org.editLandingPage(org))
        .withDefault("#"),
    },
  ];
};
